module.exports = new Promise((resolve, reject) => {
    var remoteBaseUrl = "https://web-bundles.setel.com/prod/web-pos/latest".replace(/\/$/, ''); // trim trailing slash
    // backward compat with old remotes
    (window._endpoints ??= {})["web-pos"] = remoteBaseUrl;
    // adds "remoteEntry.js" filename
    var remoteEntryUrl = remoteBaseUrl + '/' + "remoteEntry.js";
    // load remote using our custom runtime
    __webpack_require__._mf_l(remoteEntryUrl, "web_pos")
        .then(resolve)
        .catch(reject);
    });